// Специальные предложения
export function stepSpecialOffers (proxy)
{
    let controller = {
        checked: false,
        input: false,
    }

    const data = proxy.data
    const step = 'step'+data.step;
    const checkboxWrappers = proxy.fvcContainerId.querySelectorAll('.checkbox_wrapper_js');
    const totalInformationWrapper = proxy.fvcContainerId.querySelector('.total_information_wrapper');
    const bankCardSimCard = totalInformationWrapper.querySelector('.bankCardSimCard_js')

    // Активируем кнопку "Далее"
    proxy.bNext.style.display = 'block'
    const bSendRequest = document.querySelector('.b_send_request')
    if (bSendRequest) bSendRequest.remove();

    // Данные для подсчёта общей стоимости
    const dataTotalPrise = {
        totalInformation: {},
        prise: {}
    }

    // Получаем объект с LocalStorage
    const dataLocalStorage = data.getStepLocalStorage(proxy.locStorStepId, data.step);
    if (dataLocalStorage) {
        // Записываем в dataForm данные из LocalStorage
        data.setDataFormAddLocalStorage(data.dataForm[step], dataLocalStorage)
    }

    const dataLS1 = data.getStepLocalStorage(proxy.locStorStepId, 1);
    const dataLS2 = data.getStepLocalStorage(proxy.locStorStepId, 2);
    const dataLS7 = data.getStepLocalStorage(proxy.locStorStepId, 7);
    const dataLS8 = data.getStepLocalStorage(proxy.locStorStepId, 8);

    // Цена "страховки"
    const insurancePrice = dataLS7.validityInsurance.prise;
    const insuranceCheck = dataLS7.validityInsurance.check;

    if (insurancePrice && insuranceCheck) {
        dataTotalPrise.prise = {
            ...dataTotalPrise.prise,
            insurance: {
                name: proxy.message.STEP7_NAME,
                prise: insurancePrice
            }
        }
    }

    if (dataLS8) {
        // в dataTotalPrise добавляем данные с активных чекбоксов при загрузке и
        getCheckPriseLoader(dataLS8, dataTotalPrise)
    }

    // Цена "визы"
    if (dataLS1.prise && dataLS1.name) {
        dataTotalPrise.prise = {
            ...dataTotalPrise.prise,
            typeOfVisa: {
                prise: dataLS1.prise,
                name: dataLS1.name
            },
        }
    }

    // формируем при загрузке LocalStorage из установленных данных
    checkboxWrappers.forEach(checkbox => {
        const check = checkbox.querySelector('input[type=checkbox]');
        const checkboxWrapper = checkbox.closest('.checkbox_wrapper_js');
        const key = checkbox.dataset.name;
        const inputPrise = checkbox.querySelector('.input_box_price')
        const priseName = inputPrise.dataset.name

        // Если активирован чекбокс при загрузке записываем цену в дата
        if (check.checked) {
            data.dataForm[step][key][priseName] = inputPrise.innerText;

            // Контролируем чекбоксы
            initCheckControl(proxy, step, key, check, bankCardSimCard, dataTotalPrise)

            data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, data.dataForm[step], data.step);
        }

        // Вешаем событие при активации чекбокса
        check.addEventListener('customCheckClick', e => {
            const target = e.target;
            const data = e.detail.proxy.data;
            const dataForm = e.detail.dataForm;
            const dataName = checkboxWrapper.dataset.name;

            // Возвращаем DataTotalPrise с активными элементами
            getControlDataTotalPrise (dataTotalPrise, dataName, inputPrise.innerText, target.checked)

            // Устанавливаем цену
            data.dataForm[step][key][priseName] = inputPrise.innerText

            // console.log('target => ', target)
            // console.log('dataName => ', dataName)

            // Контролируем чекбоксы
            initCheckControl(proxy, step, dataName, target, bankCardSimCard, dataTotalPrise)

            addTotalInformationHtml (proxy, dataTotalPrise)

            // Выводим услуги в таблице
            renderTotalInformation (proxy, dataTotalPrise)

            // e.preventDefault();

            // Записываем выбранные цену
            data.setStepLocalStorage(e.detail.proxy.visual.LOCAL_STORAGE_STEP_ID, data.dataForm[step], data.step);
        });

    })

    // Вставляем строку в таблицу
    addTotalInformationHtml (proxy, dataTotalPrise)

    // Выводим услуги в таблице
    renderTotalInformation (proxy, dataTotalPrise)

    // console.log(data.dataForm[step])
    proxy.bNext.classList.add('in');
}

// Формируем массив данных (proxy, prise, key, name, dataTotalPrise)
function addTotalInformationHtml (proxy, dataTotalPrise) {
    let name = false;
    dataTotalPrise.totalInformation = {}

    Object.entries(dataTotalPrise.prise).forEach((entry) => {
        const [key, value] = entry;
        switch (key) {
            case "typeOfVisa":
                name = value.name
                break;
            case "insurance":
                name = 'Страховка'
                break;
            case "arrServDeliverCourierHotel":
                name = 'Банковская карта и SIM-карта'
                break;
            case "arrServGetAirport":
                name = 'Банковская карта и SIM-карта'
                break;
            case "arrServTransfer":
                name = 'Трансфер по прилёту'
                break;
            case "arrServMeetingAirport":
                name = 'Встреча в аэропорту'
                break;
            case "arrServCIPTerminal":
                name = 'Прибытие CIP терминал'
                break;
            case "departureServTransfer":
                name = 'Трансфер по вылету'
                break;
            case "departureServCIPTerminal":
                name = 'Вылет CIP терминал'
                break;
            case "fastTrack":
                name = 'Fast Track'
                break;
            case "fastTrackBusiness":
                name = 'Fast Track & Бизнес-зал'
                break;
            default:
                break;
        }
        if (key !== 'generalSum') {
            if (value.prise) {
                dataTotalPrise.totalInformation[key] = proxy.data.tableRowHtml (name, value.prise, key)
            } else {
                dataTotalPrise.totalInformation[key] = proxy.data.tableRowHtml (name, value, key)
                dataTotalPrise.prise[key] = {
                    name: name,
                    prise: value,
                }
            }
        }
    });
    // dataTotalPrise.totalInformation[key] = proxy.data.tableRowHtml (name, prise, key)
}

// Вставляем блоки в таблицу
function renderTotalInformation (proxy, dataTotalPrise) {
    const totalInformationWrapper = proxy.fvcContainerId.querySelector('.total_information_wrapper');
    totalInformationWrapper.innerHTML = ''
    let element = '';

    Object.entries(dataTotalPrise.totalInformation).forEach((entry) => {
        const [key, value] = entry;
        element += value;
    });

    // Подсчитываем общую стоимость и вставляем HTML
    element += totalCalculationAddLocalStorage(proxy, dataTotalPrise)

    totalInformationWrapper.insertAdjacentHTML("afterbegin", element)
}

// Подсчитываем общую стоимость и добавляем в LocalStorage
function totalCalculationAddLocalStorage (proxy, dataTotalPrise) {
    const priseObj = dataTotalPrise.prise;

    if (dataTotalPrise.prise.generalSum) {
        delete dataTotalPrise.prise.generalSum;
    }

    let priseResult = 0;
    Object.entries(priseObj).forEach((entry) => {
        const [key, value] = entry;
        if (value.prise) {
            priseResult += proxy.data.getNumberParser(value.prise)
        } else {
            priseResult += proxy.data.getNumberParser(value)
        }
    });

    dataTotalPrise.prise = {
        ...dataTotalPrise.prise,
        generalSum: {
            name: BX.message('TOTAL'),
            prise: proxy.data.numberWithSpaces(priseResult) + BX.message('R'),
            priseInt: priseResult
        }
    }
    proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataTotalPrise.prise, 'result');
    // localStorage.setItem(proxy.visual.LOCAL_STORAGE_STEP_ID + 'result', JSON.stringify(dataTotalPrise.prise));
    return proxy.data.tableTotalPriseHtml (proxy.data.numberWithSpaces(priseResult) + BX.message('R'))
}

// в dataTotalPrise добавляем данные с активных чекбоксов при загрузке
function getCheckPriseLoader (dataLS8, dataTotalPrise) {
    Object.entries(dataLS8).forEach((entry) => {
        const [key, value] = entry;
        if (value.check) {
            dataTotalPrise.prise = {
                ...dataTotalPrise.prise,
                [key]: value.prise
            }
        }
    });
}

// Возвращаем DataTotalPrise с активными элементами
function getControlDataTotalPrise (dataTotalPrise, name, prise, check) {
    if (check) {
        dataTotalPrise.prise = {
            ...dataTotalPrise.prise,
            [name]: prise
        }
    } else {
        Object.entries(dataTotalPrise.prise).forEach((entry) => {
            const [key, value] = entry;
            if (key === name) {
                delete dataTotalPrise.prise[name];
            }
        });
    }

    return dataTotalPrise
}

// Контролируем чекбоксы
function initCheckControl (proxy, step, key, target, bankCardSimCard, dataTotalPrise) {
    const check = target.checked;
    proxy.data.dataForm[step][key].check = check

    // Доставить курьером в отель
    if (key === 'arrServDeliverCourierHotel') {
        checkDeliverCourierHotel(proxy, step, target, key, check, 'arrServGetAirport', bankCardSimCard, dataTotalPrise);
    }

    // Получить в аэропорту
    if (key === 'arrServGetAirport') {
        clickGetAirport(proxy, step, key, check, 'arrServDeliverCourierHotel', bankCardSimCard, dataTotalPrise);
    }

    // Вылет CIP терминал
    if (key === 'departureServCIPTerminal') {
        const keyName = ['fastTrackBusiness', 'fastTrack']
        clickFastTrackCip(proxy, step, check, keyName, dataTotalPrise);
    }

    // Fast Track
    if (key === 'fastTrack') {
        const keyName = ['fastTrackBusiness', 'departureServCIPTerminal']
        clickFastTrackCip(proxy, step, check, keyName, dataTotalPrise);
        // clickFastTrack(check, 'fastTrackBusiness', dataTotalPrise);
    }

    // Fast Track & Бизнес-зал
    if (key === 'fastTrackBusiness') {
        const keyName = ['fastTrack', 'departureServCIPTerminal']
        clickFastTrackCip(proxy, step, check, keyName, dataTotalPrise);
        // clickFastTrack(check, 'fastTrack', dataTotalPrise);
    }
}

// Доставить курьером в отель (переключаем "Встреча в аэропорту")
function checkDeliverCourierHotel (proxy, step, target, keyName, check, dataName, bankCardSimCard, dataTotalPrise) {
    const meetingAirport = document.querySelector('[data-name=arrServMeetingAirport]')
    const checkPriseWrapper = meetingAirport.querySelector('.check_prise_wrapper')
    const checkboxWrapper = checkPriseWrapper.closest('.checkbox_wrapper_js')
    const inputBoxPrice = meetingAirport.querySelector('.input_box_price')
    const input = meetingAirport.querySelector('input')
    const prise = target.closest('.check_prise_wrapper').querySelector('[data-name=prise]').innerText

    // Деактивируем "Встреча в аэропорту" при загрузке
    //input.disabled = true
    //checkPriseWrapper.classList.add('off')
    //inputBoxPrice.innerHTML = ''

    const getAirport = document.querySelector(`[data-name=${dataName}]`)
    const getAirportInput = getAirport.querySelector('input')
    const getAirportCheckPriseWrapper = getAirport.querySelector('.check_prise_wrapper')

    getAirportCheckPriseWrapper.classList.remove('off')
    getAirportInput.disabled = false

    if (check) {
        // Деактивируем "Встреча в аэропорту"
        /*if (getAirport.classList.contains('active')) {
            getAirport.classList.remove('active')
        }
        if (checkboxWrapper.classList.contains('active')) {
            checkboxWrapper.classList.remove('active')
        }*/

        // Устанавливаем "Встреча в аэропорту" не активный
        proxy.data.dataForm[step].arrServMeetingAirport = {
            check: false,
            prise: false,
            // prise: proxy.message['STEP8_MEETING_AIRPORT_PRISE_R'],
        }

        // Удаляем с dataTotalPrise "Встреча в аэропорту"
        // if (dataTotalPrise.prise.arrServMeetingAirport) {
        //     delete dataTotalPrise.prise.arrServMeetingAirport
        // }

        // checkPriseWrapper.classList.add('off')
        // input.disabled = true
        // inputBoxPrice.innerHTML = ''

        getAirportCheckPriseWrapper.classList.add('off')
        getAirportInput.checked = false
        getAirportInput.disabled = true
    } else {
        if (dataTotalPrise.totalInformation[keyName]) {
            delete dataTotalPrise.totalInformation[keyName]
        }
    }
}

// Получить в аэропорту (переключаем "Трансфер" и "Встреча в аэропорту")
function clickGetAirport (proxy, step, keyName, check, dataName, bankCardSimCard, dataTotalPrise) {
    const transfer = document.querySelector('[data-name=arrServTransfer]')
    const meetingAirport = document.querySelector('[data-name=arrServMeetingAirport]')
    const deliverCourierHotel = document.querySelector(`[data-name=${dataName}]`)

    transferMeetingAirport (proxy, transfer, check, deliverCourierHotel, dataTotalPrise);
    transferMeetingAirport (proxy, meetingAirport, check, deliverCourierHotel, dataTotalPrise);

    // Получить в аэропорту (переключатель двух полей "Трансфер", "Встреча в аэропорту")
    function transferMeetingAirport (proxy, item, checked, deliverCourierHotel, dataTotalPrise) {
        if (item) {
            const inputCont = item.querySelector('input')
            const parentCheck = item.closest('.checkbox_wrapper_js');
            const formContBox = item.closest('.form_cont_box');
            const inputBoxPrice = parentCheck.querySelector('.input_box_price')

            // Устанавливаем цену по умолчанию в "Трансфер" если не активирован "Доставить курьером в отель"
            if (item.dataset.name === 'arrServTransfer') {
                // const prise = '3 500 ₽';
                inputBoxPrice.innerHTML = proxy.message['STEP8_SERV_TRANSFER_PRISE_R'];
                // dataTotalPrise.prise.arrServTransfer = prise
                // totalCalculation(dataTotalPrise)
            }

            const input = deliverCourierHotel.querySelector('input')
            const checkPriseWrapper = deliverCourierHotel.querySelector('.check_prise_wrapper')
            const meetingAirportPriseWrapper = meetingAirport.querySelector('.check_prise_wrapper')

            parentCheck.classList.remove('active');
            formContBox.classList.remove('active');
            inputCont.checked = checked
            inputCont.disabled = false

            checkPriseWrapper.classList.remove('off')
            input.disabled = false

            // Если активирован чекбокс
            if (checked) {
                // meetingAirportPriseWrapper.classList.remove('off')

                // Устанавливаем "Трансфер" в ноль
                proxy.data.dataForm[step].arrServTransfer = {
                    check: true,
                    prise: "0 ₽",
                }
                dataTotalPrise.prise.arrServTransfer = "0 ₽"

                // Устанавливаем "Встреча в аэропорту" в ноль
                proxy.data.dataForm[step].arrServMeetingAirport = {
                    check: true,
                    prise: "0 ₽",
                }
                dataTotalPrise.prise.arrServMeetingAirport = "0 ₽"

                formContBox.classList.add('active');
                parentCheck.classList.add('active');

                checkPriseWrapper.classList.add('off')
                inputBoxPrice.innerHTML = '0 ₽'
                input.checked = false
                input.disabled = true
            } else {

                // Делаем не активность для "Встреча в аэропорту"
                // meetingAirportPriseWrapper.classList.add('off')
                // meetingAirportPriseWrapper.querySelector('input').disabled = true
                meetingAirportPriseWrapper.querySelector('.input_box_price').innerText = proxy.message['STEP8_MEETING_AIRPORT_PRISE_R']

                // "Трансфер" делаем не активной
                proxy.data.dataForm[step].arrServTransfer = {
                    check: false,
                    prise: false,
                    // prise: proxy.message['STEP8_SERV_TRANSFER_PRISE_R'],
                }

                delete dataTotalPrise.prise.arrServTransfer

                // "Встреча в аэропорту" делаем не активной
                proxy.data.dataForm[step].arrServMeetingAirport = {
                    check: false,
                    prise: false,
                    // prise: proxy.message['STEP8_MEETING_AIRPORT_PRISE_R'],
                }

                delete dataTotalPrise.prise.arrServMeetingAirport
            }
        }
    }
}

// Клик по "Fast Track, Бизнес-зал и CIP" деактивация и активация
function clickFastTrackCip (proxy, step, check, keyName, dataTotalPrise)
{
    keyName.forEach(key => {
        const container = document.querySelector(`[data-name=${key}]`)
        const checkPriseWrapper = container.querySelector('.check_prise_wrapper')

        const input = container.querySelector('input')
        container.classList.remove('active');
        checkPriseWrapper.classList.remove('off')

        input.disabled = false

        if (check) {
            checkPriseWrapper.classList.add('off')
            input.checked = false
            input.disabled = true

            if (dataTotalPrise.prise[key]) {
                delete dataTotalPrise.prise[key]
                proxy.data.dataForm[step][key] = {
                    check: false,
                    prise: false,
                }
            }
        }
    })
}

// (Переписал) Клик по "Fast Track и Бизнес-зал" деактивация и активация
function clickFastTrack (check, dataName, dataTotalPrise) {
    const container = document.querySelector(`[data-name=${dataName}]`)
    const checkPriseWrapper = container.querySelector('.check_prise_wrapper')
    const input = container.querySelector('input')

    container.classList.remove('active');
    checkPriseWrapper.classList.remove('off')
    input.disabled = false

    // Если активирован чекбокс
    if (check) {
        checkPriseWrapper.classList.add('off')
        input.checked = false
        input.disabled = true

        // Устанавливаем "Встреча в аэропорту" в ноль
        // proxy.data.dataForm[step][dataName] = {
        //     check: false,
        //     prise: "0 ₽",
        // }

        if (dataTotalPrise.prise[dataName]) {
            delete dataTotalPrise.prise[dataName]
        }

        // if (dataTotalPrise.totalInformation[dataName]) {
        //     delete dataTotalPrise.totalInformation[dataName]
        // }
    }
}

// получаем Цену "Банковская карта и SIM-карта"
function getBankCardSimCardPrise (dataLS8) {
    const checkDeliverCourierHotel = dataLS8.arrServDeliverCourierHotel.check
    const priseDeliverCourierHotel = dataLS8.arrServDeliverCourierHotel.prise

    const checkGetAirport = dataLS8.arrServGetAirport.check
    const priseGetAirport = dataLS8.arrServGetAirport.prise

    let prise = false;
    if (checkDeliverCourierHotel) {
        prise = priseDeliverCourierHotel;
    } else if (checkGetAirport) {
        prise = priseGetAirport;
    }

    return prise;
}

// Вставляем цену в таблицу "Банковская карта и SIM-карта"
function setTableBankCardSimCardHtml (prise, check, bankCardSimCard, dataTotalPrise) {
    // let prise = '0 ₽';

    // console.log('keyName => ', keyName)

    // const checkName = document.querySelector(`[data-name=${keyName}]`)

    // if (check) {
    //     prise = checkName.querySelector('[data-name=prise]').innerText
    // }

    // dataTotalPrise.prise.bankSimCard = prise
    // totalCalculation(dataTotalPrise)

    // dataTotalPrise.prise.bankSimCard

    // bankCardSimCard.innerHTML = prise
}

// Обновляем блоки в таблицу
/*function updateTotalInformation (proxy, dataTotalPrise) {
    const totalInformationWrapper = proxy.fvcContainerId.querySelector('.total_information_wrapper');
    let element = '';

    Object.entries(dataTotalPrise.totalInformation).forEach((entry) => {
        const [key, value] = entry;
        element += value;
    });

    totalInformationWrapper.insertAdjacentHTML("afterbegin", element)
}*/